import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des sections de devis.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEstimateSectionList = (token) => {
    const url = `/api-v1/admin/estimate/section/list`;
    return getRequest(url, token)
};

/**
 * Récupération de la liste des modèles de devis.
 *
 * @param string $token Jeton d'authentification.
 * @param int $sectionId Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEstimateTemplateList = (section, token, pageNumber, itemsPerPage) => {
    const url = `/api-v1/estimate/section/${section}/template/${pageNumber}/${itemsPerPage}/list`;
    return getRequest(url, token)
};

/**
 * Création d'une section de devis.
 *
 * @param object $body Données de la requête.
 * @param string $token Jeton d'authentification.
 */
export const createEstimateSection = (body, token) => {
    const url = `/api-v1/estimate/section/add`;
    return postRequest(url, body, token)
};

/**
 * Lecture d'une ligne de devis.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la ligne de devis.
 * @return Response | null Réponse de la requête à l'API.
 */
export const getEstimateLine = (token, id) => {
    const url = `/api-v1/admin/estimate/template/${id}/line`;
    return getRequest(url, token)
};

/**
 * Lecture de la liste des catégories de devis.
 *
 * @param token Jeton d'authentification.
 * @return Response | null Réponse de la requête à l'API.
 */
export const getEstimateCategoryList = (token) => {
    const url = `/api-v1/admin/estimate/category/list`;
    return getRequest(url, token)
};

/**
 * Lecture d'une catégorie de devis.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la catégorie de ligne de devis.
 * @return Response | null Réponse de la requête à l'API.
 */
export const getEstimateCatInfos = (token, id) => {
    const url = `/api-v1/admin/estimate/category/${id}/infos`;
    return getRequest(url, token)
};

/**
 * Mise à jour d'une catégorie de devis.
 *
 * @param token Jeton d'authentification.
 * @param body Données de la requête.
 * @return Response | null Réponse de la requête à l'API.
 */
export const updateEstimateCatInfos = (token, body) => {
    const url = `/api-v1/admin/estimate/category/update`;
    return postRequest(url, body, token)
};

/**
 * Suppression d'une catégorie de devis.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la catégorie de devis.
 */
export const deleteEstimateCategory = (token, id) => {
    const url = `/api-v1/admin/estimate/category/delete`;
    return postRequest(url, id, token)
};

/**
 * Modiffication d'une section de devis.
 *
 * @param token Jeton d'authentification.
 * @param body Données de la requête.
 * @return Response | null Réponse de la requête à l'API.
 */
export const updateEstimateSection = (token, body) => {
    const url = `/api-v1/admin/estimate/section/update`;
    return postRequest(url, body, token)
}

/**
 * Déplacer section vers le haut.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la section.
 */
export const uploadSectionPositionUp = (token, id) => {
    const url = `/api-v1/admin/estimate/section/${id}/up`;
    return getRequest(url, token)
};

/**
 * Déplacer section vers le bas.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la section.
 */
export const uploadSectionPositionDown = (token, id) => {
    const url = `/api-v1/admin/estimate/section/${id}/down`;
    return getRequest(url, token)
};

/**
 * Création ou mise à jour d'une ligne de devis.
 *
 * @param token Jeton d'authentification.
 * @param body Données de la requête.
 * @return Response | null Réponse de la requête à l'API.
 */
export const updateEstimateLine = (token, body) => {
    const url = `/api-v1/admin/estimate/line/update`;
    return postRequest(url, body, token)
};

/**
 * Suppression d'une ligne de devis.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la ligne de devis.
 * @return Response | null Réponse de la requête à l'API.
 */
export const deleteEstimateLine = (token, id) => {
    const url = `/api-v1/admin/estimate/line/delete`;
    return postRequest(url, id, token)
};

/**
 * Changer le statut d'une section de devis.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la section de devis.
 */
export const updateSectionStatus = (token, body) => {
    const url = `/api-v1/admin/estimate/section/enable`;
    return postRequest(url, body, token)
};

/**
 * Suppression d'une section de devis.
 *
 * @param token Jeton d'authentification.
 * @param sectionNum Numéro de la section de devis.
 * @return Response | null Réponse de la requête à l'API.
 */
export const deleteEstimateSection = (token, sectionNum) => {
    const url = `/api-v1/admin/estimate/section/delete`;
    return postRequest(url, sectionNum, token)
};

/**
 * Changement de visibilité d'une ligne de devis.
 *
 * @param token Jeton d'authentification.
 * @param body Identifiant de la ligne de devis.
 */
export const updateLineStatus = (token, body) => {
    const url = `/api-v1/admin/estimate/line/enable`;
    return postRequest(url, body, token)
};

/**
 * Changement de visibilité d'une catégorie de devis.
 *
 * @param token Jeton d'authentification.
 * @param body Identifiant de la catégorie de devis.
 */
export const updateCategoryStatus = (token, body) => {
    const url = `/api-v1/admin/estimate/category/enable`;
    return postRequest(url, body, token)
};